<template>
  <div class="projects-wrapper">
    <router-link
      v-for="p in projects"
      :key="p.project_id"
      class="projects-wrapper__item project-item"
      :to="`/projects/${p.project_id}`"
    >
      <img :src="p.images[0]" alt="Изборажение проекта" />
      <div class="project-item__info project-info">
        <h3 class="project-info__title">{{ p.info.name }}</h3>
        <AppButton :to="`/projects/${p.project_id}`">Смотреть</AppButton>
      </div>
    </router-link>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import AppButton from '@/components/ui/AppButton/Index.vue'

export default defineComponent({
  name: 'AppProjectsBlock',
  components: { AppButton },
  props: {
    projects: {
      type: Array,
      default: () => [],
    },
  },
})
</script>

<style lang="scss" scoped src="./Index.scss" />
